import { gql } from "@apollo/client";

import {
  CAMPAIGN_WITH_CALLEE_FIELDS,
  CAMPAIGN_WITH_QUESTIONS
} from "./fragments";

export const addCalleeFieldToCampaign = gql`
  ${CAMPAIGN_WITH_CALLEE_FIELDS}
  ${CAMPAIGN_WITH_QUESTIONS}
  mutation campaignCreateCalleeField(
    $campaignId: ID!
    $input: CampaignCreateCalleeFieldInput!
  ) {
    campaignCreateCalleeField(campaignId: $campaignId, input: $input) {
      ...CampaignWithCalleeFields
      ...CampaignWithQuestions
    }
  }
`;

export const editCampaigncalleeField = gql`
  ${CAMPAIGN_WITH_CALLEE_FIELDS}
  ${CAMPAIGN_WITH_QUESTIONS}
  mutation campaignEditCalleeField(
    $campaignId: ID!
    $fieldId: ID!
    $input: CampaignEditCalleeFieldInput!
  ) {
    campaignEditCalleeField(
      campaignId: $campaignId
      fieldId: $fieldId
      input: $input
    ) {
      ...CampaignWithCalleeFields
      ...CampaignWithQuestions
    }
  }
`;

export const deleteCalleeFieldFromCampaign = gql`
  ${CAMPAIGN_WITH_CALLEE_FIELDS}
  ${CAMPAIGN_WITH_QUESTIONS}
  mutation campaignDeleteCalleeField($campaignId: ID!, $fieldId: ID!) {
    campaignDeleteCalleeField(campaignId: $campaignId, fieldId: $fieldId) {
      ...CampaignWithCalleeFields
      ...CampaignWithQuestions
    }
  }
`;
